
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jewels",
      function () {
        return require("private-next-pages/jewels/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jewels"])
      });
    }
  